<template>
  <div class="base-tab">
    <template v-for="(item,index) in titles">
      <div class="base-tab-item" @click="changeTab(index)" :key="index">
        <div class="base-tab-item-label" :style="index+1 == activeName?'color: #194DFF':''">{{item}}</div>
        <div class="active-line" :style="index+1 == activeName?'background-color: #194DFF':''"></div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BaseTab',
  model: {
    prop: 'value',
    event: 'propEvent',
  },
  props: {
    value: { type: String, default: '' },
    titles: { type: Array, default() { return [] }, },
  },
  data() {
    return {
      activeName: this.value,
    }
  },
  created() {},
  mounted() {},
  computed: {},
  watch:{
    activeName(val) {
      this.$emit('propEvent', val)
    },
  },
  methods: {
    changeTab(index){
      this.activeName = index+1+''
      this.$emit('changeTab', this.activeName)
    }
  },
}
</script>

<style lang="less" scoped>
  .base-tab{
    height: 38px;
    display: flex;
    border-bottom: 1px solid #D5D9E0;
  }
  .base-tab-item{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 100%;
    padding: 0 12px;
    cursor: pointer;
  }
  .base-tab-item-label{
    display: flex;
    align-items: center;
    height:100%;
    font-size: 14px;
    font-weight: 400;
    color: #3a485e;
    line-height: 14px;
  }
  .base-tab-item:first-child{
    padding-left: 20px;
  }
  .base-tab-item:hover{
    color: #194DFF;
  }
  .active-line{
    position: relative;
    width: 28px;
    height: 2px;
    bottom: 0;
  }

</style>

<style lang="less">
</style>
